@if (showTableTop) {
	<pcg-table-top
		#tableTop
		[canGlobalSearch]="canGlobalSearch"
		[canShowHideColumns]="canShowHideColumns" 
		[pageSizeSource]="pageSizeSource"
		[filterSource]="filterSource"
		[pageLengths]="pageLengths"
		[exactMatchSource]="exactMatchSource"
		[columnDefs]="columnDefs"
		[filterId]="filterId"
		[filters]="(filterId ? ajaxData : null)"
		[emptyFilters]="emptyFilters"
		[customResetFiltersMap]="customResetFiltersMap"
		[ajaxData]="ajaxData"
		[canResetFilters]="canResetFilters"
		[filterMap]="filterMap"
		[canExportTableToExcel]="canExportTableToExcel"
		[canPrintTable]="canPrintTable"
		[hasTooltips]="hasTooltips"
		[showTooltipsBtn]="showTooltipsBtn"
		[tooltipContent]="tooltipContent"
		[canToggleUnits]="canToggleUnits"
		[canToggleInventoryTypes]="canToggleInventoryTypes"
		[canToggleUserPermissions]="canToggleUserPermissions"
        [canToggleDepartments]="canToggleDepartments && user?.useDepartments"
		[canToggleTableHeaders]="canToggleTableHeaders"
		[table]="this"
		[showTilesBtn]="showTilesBtn"
		(isUsingTiles)="tableViewClick($event)"
		[tableViewStorage]="tableViewStorage"
        [legend]="legend"
        (reloadTable)="ajaxReload()"
	></pcg-table-top>
}

<tr 
	class="search-row" 
	*matHeaderRowDef="getColHeaderDefs()" 
	mat-header-row
></tr>
<tr 
	class="footer-row" 
	*matFooterRowDef="getVisibleColDefs()" 
	mat-footer-row
></tr>

<!-- Desktop Table -->
<section
	[class.d-none]="
		isMobile()
		&& (
			isUsingMobileCard
			|| isUsingNewMobileCard
			|| isProductsList
			|| isAssociationList
		)
	"
	aria-label="Table"
	#tableContainer
	[class.pcg-table-responsive]="isResponsive"
	[class.pcg-table-fixed-footer]="fixedFooter"
	[class.pcg-table-fixed-header]="fixedHeader"
	class="pcg-table-container mb-1"
>
	<!-- Table Tiles -->
    <div 
        class="row mt-2"
        [class.d-none]="!showTiles"
    >
        <div class="tile-card-container">
            @for (data of tableData?.data; track data) {
                <div style="flex: .25; min-width: 20%;">
                    <div class="card mb-2 tile-card">
                        <div class="tile-card-header">
                            <div class="row">
                                <div class="col-md-9">
                                    <h6>{{ data[tileHeaderColumn] }}</h6>
                                </div>

                                <div class="col-md-3 text-right">
                                    <pcg-edit-link [url]="editLink + data[identificationColumn]">
                                        <fa-icon 
                                            [icon]="faIcons.faPenToSquare" 
                                            class="pen-to-square"
                                        ></fa-icon>
                                    </pcg-edit-link>
                                </div>
                            </div>
                            @if (data[tileSubHeaderColumn] !== '') {
                                <div class="row">
                                    <div class="col-md-12">
                                        <h6 class="card-subtitle mt-2 text-muted">{{ data[tileSubHeaderColumn] }}</h6>
                                    </div>
                                </div>
                            }
                        </div>

                        <div 
                            class="text-nowrap text-left"
                            (click)="redirectFunction(data)"
                        >
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item">
                                    @for (row of tilesMap; track row) {
                                        <div class="tile-list-item">
                                            <h6 
                                                class="left" 
                                                [innerHtml]="columnDefs.get(row[0]).displayName"
                                            ></h6>
                                            <span 
                                                class="right" 
                                                [innerHtml]="sanitizer.bypassSecurityTrustHtml(row[1](data))"
                                            ></span>
                                        </div>
                                    }
                                </li>
                                @if (
                                    canEdit
                                    && getVisibleColDefs().includes('canDelete')
                                    && (
                                        data['canDelete']
                                        || isAdmin
                                    )
                                ) {
                                    <li class="list-group-item">
                                        <pcg-delete-button
                                            class="delete-btn-table"
                                            [table]="this"
                                            [confirmMessage]="confirmMessage"
                                            [url]="deleteUrl"
                                            [id]="data[identificationColumn]"
                                            [isUsingComment]="isUsingDeleteComment"
                                        ></pcg-delete-button>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            }
        </div>

        @if (tableData?.data?.length === 0) { <div class="no-records-table">No records to display</div> }
    </div>
	
	<!-- Table list -->
	<table 
		[dataSource]="dataOnPageSource" 
		mat-table 
		class="data-grid" 
		[class]="'pcg-table-' + tableNum"
		[class.d-none]="showTiles"
	>
		<!-- Displayed if no records are in the table -->
		<ng-container matColumnDef="noRecords">
			<td 
				colspan="999" 
				mat-cell 
				*matCellDef="let row"
			>
				@if (
					hasCompletedServerRequest 
					|| !serverSide
				) { <div>No records to display</div> }
				@if (
					!hasCompletedServerRequest 
					&& serverSide
				) { <div>Loading...</div> }
			</td>
		</ng-container>

		<!-- Optional per column search -->
		@for (col of getColDefs(); track col; let i = $index) {
            <ng-container [matColumnDef]="col + '_search'">
                <th 
                    [class]="getColSearchClasses(col)" 
                    mat-header-cell 
                    *matHeaderCellDef="let row"
                >
                    @if (
                        canSearch(col) 
                        && isNdc(col)
                    ) {
                        <input
                            [value]="perColumnSearchSource.value[i]"
                            (keyup)="updatePerColumnSearch(i, $event.target.value)"
                            (search)="updatePerColumnSearch(i, $event.target.value)"
                            [attr.aria-label]="'Search ' + columnDefs.get(col)?.displayName"
                            placeholder="Search..."
                            class="form-control form-control-sm hide-on-print"
                            mask="00000-0000-00"
                            type="search"					
                        />
                    }
                    @if (
                        canSearch(col) 
                        && isNdc10(col)
                    ) {
                        <input
                            [value]="perColumnSearchSource.value[i]"
                            (keyup)="updatePerColumnSearch(i, $event.target.value)"
                            (search)="updatePerColumnSearch(i, $event.target.value)"
                            [attr.aria-label]="'Search ' + columnDefs.get(col)?.displayName"
                            placeholder="Search..."
                            class="form-control form-control-sm hide-on-print"
                            mask="0000000000"
                            type="search"					
                        />
                    }
                    @if (
                        canSearch(col) 
                        && (
                            !isNdc(col) 
                            && !isNdc10(col)
                        )
                    ) {
                        <input
                            [value]="perColumnSearchSource.value[i]"
                            (keyup)="updatePerColumnSearch(i, $event.target.value)"
                            (search)="updatePerColumnSearch(i, $event.target.value)"
                            [attr.aria-label]="'Search ' + columnDefs.get(col)?.displayName"
                            placeholder="Search..."
                            class="form-control form-control-sm hide-on-print"
                            type="search"					
                        />
                    }
                </th>
            </ng-container>
        }

		<!-- Header and Row Declarations -->
		<tr 
			mat-header-row 
			*matHeaderRowDef="getVisibleColDefs()" 
			class="reduce-height"
		></tr>
		<tr 
			mat-row 
			*matRowDef="let row; when: hasData; columns: getVisibleColDefs()" 
			(click)="emitClick(row)" 
			[class]="isRowClickable === true ? 'clickable-row' : ''"
		></tr>
		<tr 
			mat-row 
			*matRowDef="let row; when: hasNoData; columns: ['noRecords']"
		></tr>
	</table>
</section>

<!-- Mobile cards -->
 @if (
	isMobile() 
	&& isUsingMobileCard
 ) {
	<div>
		@for (data of tableData?.data; track data) {
			<div 
				class="list-card" 
				(click)="redirectFunctionEmit ? clickRow.emit(data) : redirectFunction(data)"
			>
				<div 
					class="unique-field" 
					[ngClass]="{'discrepancy-color' : data?.isDiscrepancy}"
				>
					<div class="alert-field">
						@if (data?.isDiscrepancy) { <h8 class="alert-bubble">DISCREPANCY</h8> }					
					</div>
		
					@if (
						showMobileEdit
						&& isAdmin
						&& canEdit
					) {
						@if (editLink) {
							<pcg-edit-link [url]="editLink + data[identificationColumn]">
								<fa-icon
									[icon]="faIcons.faPenToSquare"
									class="pen-to-square"
								></fa-icon>
							</pcg-edit-link>
						} @else {
                            <fa-icon
								[icon]="faIcons.faPenToSquare" 
								class="pen-to-square"
								(click)="editEventEmitter.emit(data); $event.stopPropagation()"
							></fa-icon>
						}
					}
		
					<div class="unique-item w-100">
						@if (!ignoreUniqueColumnName) { <p>{{ columnDefs.get(uniqueColumn).displayName  }}</p> }
                        @if (mobileMap?.has(uniqueColumn)) { <h6 [innerHTML]="mobileMap?.get(uniqueColumn)(data)"></h6> }
                        @else { <div class="w-100 card-list-item p-0"><h6>{{ data[uniqueColumn] }}</h6></div> }
					</div>
		
					<div class="delete-field">
						@if (
							canEdit
							&& getVisibleColDefs().includes('canDelete')
							&& (
								data['canDelete']
								|| isAdmin
							)
						) {
                            @if (isMedUseList) {
                                <pcg-delete-button
                                    class="delete-btn-table"
                                    [table]="this"
                                    [confirmMessage]="confirmMessage"
                                    [url]="deleteUrl"
                                    [id]="data[identificationColumn]"
                                    [isUsingComment]="data['status'] == 'Finalized'"
                                    (delete)="deleteEventEmitter.emit($event)"
                                ></pcg-delete-button>
                            } @else {
                                <pcg-delete-button
                                    class="delete-btn-table"
                                    [table]="this"
                                    [confirmMessage]="confirmMessage"
                                    [url]="deleteUrl"
                                    [id]="data[identificationColumn]"
                                    [isUsingComment]="isUsingDeleteComment || data.useDeleteComment"
                                    (delete)="deleteEventEmitter.emit($event)"
                                ></pcg-delete-button>
                            }
						}
					</div>
				</div>
		
				@if (getMobileColDefs()?.length > 0) {
					<div class="list-field">
						@for (colKey of getMobileColDefs(); track colKey) {
							<div class="card-list-item">
								<p>{{ columnDefs.get(colKey).displayName }}</p>
								@if (customTableData[colKey]) {
									<ng-container *ngTemplateOutlet="customTableData[colKey]; context: { row: data }"></ng-container>
								} @else {
									@if (!mobileMap?.has(colKey)) { <h6>{{ data[colKey] }}</h6> }
									@else { <h6 [innerHTML]="mobileMap?.get(colKey)(data)"></h6> }
								}
							</div>
						}
					</div>
				}
			</div>
		}
		
		@if (tableData?.data?.length === 0) { <div class="no-records-table">No records to display</div> }	
	</div>
 }

 <!--Mobile View 2 -->
 @if (
	isMobile()
	&& isUsingNewMobileCard
 ) {
	@for (data of tableData?.data; track data) {
		<div 
			class="list-card d-flex flex-column mb-3 w-100 list-parent-container" 
			(click)="redirectFunctionEmit ? clickRow.emit(data) : redirectFunction(data)"
		>
			<div class="d-flex flex-row justify-content-between align-items-center w-100 list-header">
				<div 
					class="unique-field2"
					[ngClass]="{'discrepancy-color' : data?.isDiscrepancy}"
				>
					<div class="p-2 d-flex flex-row flex-wrap">
						@if (data?.isDiscrepancy) {
                            <div class="alert-field2">
							    @if (data?.isDiscrepancy) { <h8 class="alert-bubble">DISCREPANCY</h8> }					
						    </div>
                        }
                        @if (mobileMap?.has(uniqueColumn)) { <h6 [innerHTML]="mobileMap?.get(uniqueColumn)(data)"></h6> }
                        @else {
                            @if (!ignoreUniqueColumnName) { <p>{{ columnDefs.get(uniqueColumn).displayName  }}</p> }
                            <h4>{{ data[uniqueColumn] }}</h4>
                        }
						
						<div class="ml-2">
							@if (
								showMobileEdit
								&& isAdmin
								&& canEdit
							) {
								@if (editLink) {
									<pcg-edit-link [url]="editLink + data[identificationColumn]">
										<fa-icon
											[icon]="faIcons.faPenToSquare"
											class="pen-to-square"
										></fa-icon>
									</pcg-edit-link>
								} @else {
									<fa-icon
										[icon]="faIcons.faPenToSquare" 
										class="pen-to-square"
										(click)="editEventEmitter.emit(data); $event.stopPropagation()"
									></fa-icon>
								}
							}
						</div>

						<div class="mobile-card-top-right-container">
                            @if (mobileCardTopRight != null) {
                                <ng-container *ngTemplateOutlet="mobileCardTopRight; context: { row: data }"></ng-container>
                            }

							@if (
								canEdit
								&& (
									getVisibleColDefs().includes('canDelete')
									|| getVisibleColDefs().includes('delete')
									&& (
										data['canDelete']
										|| data['delete']
										|| isAdmin
									)
								)
							) { @if (!useDeleteEventEmmiter) {
									<pcg-delete-button
										class="delete-btn-table"
										[table]="this"
										[confirmMessage]="confirmMessage"
										[url]="deleteUrl"
										[id]="data[identificationColumn]"
										[isUsingComment]="isUsingDeleteComment || data.useDeleteComment"
									></pcg-delete-button>
								} @else {
									<pcg-delete-button
										class="delete-btn-table"
										[table]="this"
										[confirmMessage]="confirmMessage"
										[url]="deleteUrl"
										[id]="data[identificationColumn]"
										[isUsingComment]="isUsingDeleteComment || data.useDeleteComment"
										(delete)="deleteEventEmitter.emit($event)"
									></pcg-delete-button>
								}
							}
						</div>
					</div>					
				</div>
			</div>
			<div>
				@if (getMobileColDefs()?.length > 0) {
					<div class="list-field">
						@for (row of getMobileColDefs(); track row) {
							@if (!(columnDefs.get(row).displayName=='CanDelete' || columnDefs.get(row).displayName=='Delete')) {
                                <div class="card-list-item2">
                                    <p>{{ columnDefs.get(row).displayName }}</p>
                                    @if (!mobileMap?.has(row)) { <h6>{{ data[row] }}</h6> }
                                    @if (mobileMap?.has(row)) { <h6 [innerHTML]="mobileMap?.get(row)(data)"></h6> }
                                </div>
                            }
						}
					</div>
				}
			</div>
		</div>
	}
 }

<!-- Products List Mobile View -->
@if (
	isMobile() 
	&& isProductsList
) {
	@for (parentProduct of parentProducts; track parentProduct) {
		<div class="d-flex flex-column mb-3 w-100 list-parent-container">
			<div class="d-flex justify-content-between align-items-center w-100 p-2 list-header">
                @if (
                    autoDeactivateZeroStock
                    && parentProduct.childCount == 1
                    && parentProduct.currentStock == 0
                    && parentProduct.isActive
                    && parentProduct.daysUntilDeactivation != null
                    && parentProduct.daysUntilDeactivation >= 0
                ) {
                    <h4>{{ parentProduct.productName }}</h4> 
                    <span class="red-chip chip-padding-and-font-size ml-2 float-right">
                        <b>{{ parentProduct.daysUntilDeactivation }}</b> days
                    </span>
                } @else { <h4>{{ parentProduct.productName }}</h4> }
				<div>
                    @if (
                        par.hasPar(parentProduct.minimumDesiredStock, parentProduct.maximumDesiredStock)
                    ) {
						<p class="m-0 text-right">PAR</p>
						<h6 class="text-right">
							@if (
								par.isBelow(parentProduct.currentStock, parentProduct.minimumDesiredStock)
							) { <span class="yellow-chip chip-padding-and-font-size"><b>BELOW</b></span> }
							@if (
								par.isAbove(parentProduct.currentStock, parentProduct.maximumDesiredStock)
							) { <span class="scarlet-chip chip-padding-and-font-size"><b>ABOVE</b></span> }
							@if (
								par.isOut(parentProduct.currentStock, parentProduct.minimumDesiredStock)
							) { <span class="red-chip chip-padding-and-font-size"><b>OUT</b></span> }
							{{ par.formatRange(parentProduct.minimumDesiredStock, parentProduct.maximumDesiredStock, parentProduct.unitType) }}
						</h6>
                	}
				</div>
			</div>
			@for (childProduct of getChildProducts(parentProduct.productName); track childProduct) {
				<div 
					class="d-flex flex-column p-2 list-child-container"
					(click)="productsRedirect(childProduct)"
				>
					<div class="p-2 product-list-child">
						<div class="d-flex justify-content-between">
							<div>
								@if (unitTypeEnum == unitType.Units) {
									<p class="m-0">Units Remaining</p>
									<h6>{{ childProduct.currentStock | number }} {{ childProduct.unitType }}</h6>                                    
								} @else if (unitTypeEnum == unitType.Vials) {
									<p class="m-0">Vials Remaining</p>
									<h6>{{ childProduct.vialsRemaining | number }} vials</h6>
								} @else if (unitTypeEnum == unitType.Volume) {
									<p class="m-0">Volume Remaining</p>
									<h6>{{ childProduct.volumeRemaining | number }} mL</h6>
								}
                                @if (
                                    autoDeactivateZeroStock
                                    && !childProduct.isParent
                                    && childProduct.currentStock == 0
                                    && childProduct.isActive 
                                    && childProduct.daysUntilDeactivation != null
                                    && childProduct.daysUntilDeactivation >= 0
                                ) {
                                    <span class="red-chip chip-padding-and-font-size ml2-2">
                                        <b>{{ childProduct.daysUntilDeactivation }}</b> days
                                    </span>
                                }
							</div>
							<div>
								@if (childProduct.expiredVialCount > 0) {
									<div>
										<fa-icon 
											[icon]="faIcons.faStopwatch" 
											class="text-danger"
										></fa-icon>
										<small> - Expired Drugs</small>
									</div>
								} 
								@if (
									childProduct.expiringWithinDaysVialCount > 0
									&& childProduct.expiredVialCount == 0
								) {
									<div>
										<fa-icon 
											[icon]="faIcons.faStopwatch" 
											class="text-warning"
										></fa-icon>
										<small> - Expiring Drugs</small>
									</div>
								}
							</div>
						</div>
						<hr />
						<div>
							<p class="m-0 small">Per Vial</p>
							<h6 class="ml-3 small">
								{{ (childProduct.amountInOneVial / childProduct.strengthNumber) | number }} mL 
								x 
								{{ childProduct.drugStrength }}
								= 
								{{ childProduct.amountInOneVial | number }} {{ childProduct.unitType }}
							</h6>
						</div>
						<hr />
						<div class="d-flex flex-column">
							<div>
								<p class="m-0 small">Vial NDC</p>
								<h6 class="ml-3 small">{{ childProduct.ndc10 }}</h6>
							</div>
							<div class="align-self-center w-100 mt-2">
								<button 
									class="btn btn-sm btn-cancel w-100"
									(click)="productsRedirectShortcut(childProduct)"
								>View {{ user.controlValues ? "Control Values" : "Lot # & Exp." }}</button>
							</div>
						</div>
					</div>
				</div>
			}
		</div>
	}
}
@if (
	isMobile()
	&& isAssociationList
){
	<div class="container">
		<div class="row">
            @for (data of tableData?.data; track data) {
                <div class="col-12">
                    <div 
                        class="dual-list-item d-flex justify-content-between align-items-center p-2 border rounded mb-2" 
                        style="cursor: pointer;"
                        (click)="associate($event, data)"
                    >
                        <div class="d-flex align-items-center">
                            @if (isAssociateInventories) {
                                <div class="d-flex justify-content-center pr-2" style="width: 30px;">
                                    <fa-icon 
                                        [icon]="getInventoryIcon(data.type)" 
                                        style="font-size: 1.25rem;">
                                    </fa-icon>
                                </div>
                            }
                            <span class="fw-bold" style="font-size: 1rem;">{{ data[associationItemName] }}</span>
                        </div>
                        @if (canEdit) {
                            <div 
                                class="d-flex justify-content-center align-items-center rounded"
                                [class.bg-success]="fromAvailable"
                                [class.bg-danger]="!fromAvailable"
                                style="width: 30px; height: 30px; border-radius: 0.375rem;"
                            >
                                <fa-icon 
                                    [icon]="fromAvailable ? faIcons.faPlus : faIcons.faXmark" 
                                    class="text-white"
                                    style="font-size: 0.875rem;">
                                </fa-icon>
                            </div>
                        }
                    </div>
                </div>
            }
		</div>
	</div>
}

<!-- Pagination and page count -->
 @if (showNumRows) {
	<div class="d-flex-table align-items-start">
		<div class="bottom-left-container filter-count-container form-inline hide-on-print">
			<div class="d-flex-table align-items-start">
				<span class="sm">Show</span>
				<select 
					(change)="pageSizeSource.next($event.target.value)" 
					[class]="pageSizeSource.value < 1000 
						? 'form-control form-control-sm pageSize mx-sm-1 ml-1' 
						: 'form-control form-control-sm mx-sm-1 ml-1'
					"
				>
					@for (length of pageLengths; track length) {
						<option 
							aria-label="Table page length" 
							[selected]="pageSizeSource.value === length" 					
						>{{ length }}</option>
					}
				</select>
			</div>		
		</div>
		@if (showPagination) {
			<div class="w-100 mb-2 clearfix">
				<div 
					output="status" 
					aria-live="polite" 
					class="filter-count-container"
				>
					Showing
					{{ filteredDataCount === 0 ? 0 : ((currentPageSource.value - 1) * pageSizeSource.value + 1 | number) }}
					to
					{{
						(filteredDataCount < currentPageSource.value * pageSizeSource.value
							? filteredDataCount
							: currentPageSource.value * pageSizeSource.value
						) | number
					}}
					of
					{{ filteredDataCount | number }}
					entries
					@if (filteredDataCount !== totalDataCount) { <span>(filtered from {{ totalDataCount | number }} total entries)</span> }
				</div>
				
				<!-- Page switcher -->
				<div class="pagination-container hide-on-print">
					<ngb-pagination
						role="navigation"
						aria-label="Table paging"
						[collectionSize]="filteredDataCount"
						[pageSize]="pageSizeSource.value"
						[page]="currentPageSource.value"
						(pageChange)="currentPageSource.next($event)"
						[maxSize]="5"
						[rotate]="true"
					></ngb-pagination>
				</div>
			</div>
		}		
	</div>
 }